import { ParenthesisAlignedValue } from '@dealstack/frontend/shared/components/Table/MantineTable/Cells/cell.styles';
import { Flex, Text, TextProps } from '@mantine/core';
import React from 'react';

interface Props {
	value: string;
	c?: TextProps['c'];
	dataTestId?: string;
}

/** Formatted number whose digits stay aligned with negatives shown in parentheses. */
export const NumericText = ({ value, c, dataTestId }: Props) => (
	<Text size="B6Medium" c={c} truncate data-testid={dataTestId}>
		<ParenthesisAlignedValue $isNegative={value.endsWith(')')}>{value}</ParenthesisAlignedValue>
	</Text>
);

/** Right-aligned numeric table cell. */
export const NumericCell = (props: Props) => (
	<Flex align="center" justify="flex-end" w="100%" miw={0}>
		<NumericText {...props} />
	</Flex>
);
